<script type="application/ld+json">
	{     
		"@context": "http://schema.org",
		"@type": "BreadcrumbList",
		"itemListElement": [
		{
		  "@type": "ListItem",
		  "position": 1,
		  "item": {
		    "@id": "https://www.protectt.ai/",
		    "name": "Home"
		  }
		},{
		  "@type": "ListItem",
		  "position": 2,
		  "item": {
		    "@id": "https://www.protectt.ai/cyber-lab-services",
		    "name": "Cyber Lab Services"
		  }
		}		]
	}
	</script>
<!-- Breadcrumbs -->
<div class="breadcrumbs">
  <div class="container">
    <div class="row">
      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
        <ul class="breadcrumbsul">
          <li><a href="#">Home</a></li>
          <li>></li>
          <li>Cyber Lab Services</li>
        </ul>
      </div>
    </div>
  </div>
</div>
<!-- Start Introduction -->
<div style="
    background: linear-gradient(0deg, rgba(0, 0, 0, 0.0), rgba(0, 0, 0, 0.0)),
      url('assets/images/header/header-1.webp');
    background-position: right;
    background-size: cover;
  " class="section-agency-benefit section-pt section-pb-60  d-none d-md-block" (window:resize)="onResize($event)">
  <div class="container subbanner">
    <div class="row align-items-center">
      <div class="col-lg-8 col-md-8 col-xl-8">
        <div class="d-none d-sm-block" *ngIf="innerWidth > 768">
          <h1 id="bnr-heading">{{heading}}</h1>
          <h2 id="bnr-subheading"> {{subheading}}</h2>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Banner For Mobile -->

<div
  style="background: linear-gradient(0deg, rgba(0, 0, 0, 0.0), rgba(0, 0, 0, 0.0)),url('assets/images/header/header-mobile.webp'); background-position: top; background-size: cover;"
  class="section-agency-benefit section-pt section-pb-60 d-block d-md-none">
  <div class="container subbanner">
    <div class="row align-items-center">
      <div class="col-lg-12">
        <div class="mt-50">
          <!-- header background -->
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Banner Heading For Mobile -->

<div class="container d-block d-md-none" (window:resize)="onResize($event)">
  <div class="row">
    <div class="col-12">
      <div class="mt-15 mb-15 text-center" *ngIf="innerWidth <= 768">
        <h1 id="bnr-heading">{{heading}}</h1>
        <h4 id="bnr-subheading">{{subheading}}</h4>
      </div>
    </div>
  </div>
</div>

<!-- End Introduction -->

<div class="section-agency-benefit bg-gray">
  <div class="container">
    <div class="row align-items-center">
      <div class="col-lg-6">
        <div class="agency-benefits">
          <div class="content">
            <div>
              <h2>Managed Security Services</h2>
            </div>
            <p>
              Protectt.ai managed security services helps organizations to deal with cyber issues related to
              processes, data and infrastructure. Our experienced Cyber Security Consultants works with the
              organizations to effectively monitor and control threats from various applications, devices and IT
              infrastructure without any impact to the businesses.
            </p>
            <p>Our services include:</p>
            <ul id="bullets">
              <li>SOC Design & Monitoring</li>
              <li>Threat Response</li>
              <li>Red Team Exercise</li>
              <li>Real time scanning</li>
            </ul>
          </div>
        </div>
      </div>
      <div class="col-lg-6">
        <div class="agency-thumb">
          <div class="thumb">
            <img src="assets/images/cyber-lab-services/managed_security_services.webp" class="og_image_url"
              alt=" Cyber Security for Mobile Devices" />
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- End Info Area -->

<!-- Start Info Area -->
<div class="section-agency-benefit">
  <div class="container">
    <div class="row align-items-center">
      <div class="col-lg-6">
        <div class="agency-benefits">
          <div class="content">
            <div>
              <h2>Assessment Services</h2>
            </div>
            <p>
              Protectt.ai helps organizations to plan and implement comprehensive cyber solutions by nex-gen cyber
              security tools and services to enhance customer satisfaction.
            </p>
            <p>Our services include:</p>
            <ul id="bullets">
              <li>Infrastructure Security Testing</li>
              <li>Network Penetration Testing</li>
              <li>Application Security Testing</li>
              <li>Source Code Review</li>
              <li>Cloud Security</li>
            </ul>
          </div>
        </div>
      </div>
      <div class="col-lg-6 order-md-first">
        <div class="agency-thumb">
          <div class="thumb">
            <img src="assets/images/cyber-lab-services/assessment_services.webp"
              alt="Implement Cyber Security Consultants for your Business" />
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- End Info Area -->

<!-- Start Info Area -->
<div class="section-agency-benefit bg-gray">
  <div class="container">
    <div class="row align-items-center">
      <div class="col-lg-6">
        <div class="agency-benefits">
          <div class="content">
            <div>
              <h2>Advisory & Compliance Management</h2>
            </div>
            <p>
              Our trusted and experienced cyber security advisors help the organizations to be compliant. Protectt.ai
              advisors work with the business to be more proactive by implementing and ensuring, regulatory
              compliances are met without losing time and data loss.
            </p>
            <p>Our services include:</p>
            <ul id="bullets">
              <li>Risk Assessment</li>
              <li>ISO 27001</li>
              <li>ISO 22301</li>
              <li>GDPR</li>
              <li>Data Privacy</li>
              <li>PCI DSS</li>
              <li>Digital Forensics</li>
            </ul>
          </div>
        </div>
      </div>
      <div class="col-lg-6">
        <div class="agency-thumb">
          <div class="thumb">
            <img src="assets/images/cyber-lab-services/advisory_compliance.webp"
              alt="Advisory & Compliance Management" />
          </div>
        </div>
      </div>
    </div>
  </div>
</div>